import { render, staticRenderFns } from "./AdminButton.vue?vue&type=template&id=5e7412e3&scoped=true"
import script from "./AdminButton.vue?vue&type=script&lang=ts"
export * from "./AdminButton.vue?vue&type=script&lang=ts"
import style0 from "./AdminButton.vue?vue&type=style&index=0&id=5e7412e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7412e3",
  null
  
)

export default component.exports